import { createFileRoute } from '@tanstack/react-router'

import { RegistrationsScreen } from './-components/registrations-screen.tsx'

export const Route = createFileRoute('/cs-tools/registrations')({
  component: RegistrationsScreen
})
